export default __webpack_public_path__ + "static/media/nl.28521800.svg";